export default {
  message: {
    Top: {
      hello_welcome: 'Hallo, Willkommen'
    }
  }
}